module.exports = __webpack_public_path__ + "6e5949ad191dfd3aa128a6f3d6256574.png";


//////////////////
// WEBPACK FOOTER
// ./srv/public/img/widgettypes/charts/c_stacked_area.png
// module id = 892
// module chunks = 7